<template>

  <div class="fillcontain">
    <head-top></head-top>
    <div class="table_container">
      <el-row style="margin-top: 20px;">
        <el-col :span="20">
          <el-form label-width="120px" class="demo-formData">
            <el-form-item label="用户昵称:">
              <span>{{formData.userName}}</span>
            </el-form-item>
            <el-form-item label="联系方式:">
              <span>{{formData.phone}}</span>
            </el-form-item>
            <el-form-item label="反馈问题:">
              <span>{{formData.description}}</span>
            </el-form-item>
            <el-form-item label="相关图片:">
              <ul v-for="(item,index) in formData.imageList" :key="index">
                <li style="float:left">
                  <img :src="item.imageUrl" style="width:80px;height:80px;cursor: pointer;" @click="enlarge(item.imageUrl)">
                </li>
              </ul>
            </el-form-item>
            <el-form-item label="解决情况:">
              <span v-if="formData.state==0">未解决</span>
              <span v-if="formData.state==1">已解决</span>
              <el-button v-if="formData.state==0" @click="solve(formData.id)">成功解决</el-button>
            </el-form-item>
            <el-form-item>
              <el-button @click="cancel">返回</el-button>
            </el-form-item>
          </el-form>
          
        </el-col>
      </el-row>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="40%">
      <img :src="url" style="width:100%"/>
    </el-dialog>
  </div>
</template>

<script>
  import headTop from '@/components/headTop'
  import { getFeedDetail,getSolve } from "../api/api"
  export default {
    data(){
      return {
        tableData: [],
        formData: [],
        fooData:[],
        limit:20,
        currentPage:1,
        formLabelWidth: '120px',
        dialogVisible:false,
        url:''
      }
    },
    components: {
      headTop,
    },
    methods:{
      formatDate:function (value){
        var dateee = new Date(value.createTime).toJSON();
        return new Date(+new Date(dateee)+8*3600*1000).toISOString().replace(/T/g,' ').replace(/\.[\d]{3}Z/,'')
      },
      //机构用户详情
      getFeedDetail(){
        getFeedDetail({
          id:this.$route.query.id
        }).then(res=>{
          this.formData = res.data
        }).catch(error=>{
          console.log(error);
        })
      },
      solve(id){
        getSolve({
          id:id,
          state:1
        }).then(res=>{
          this.$message({
            type: 'success',
            message: '成功'
          });
          this.$router.back(-1)
        }).catch(error=>{
          console.log(error);
        })
      },
      cancel(){
        this.$router.back(-1)
      },
      enlarge(url){
        this.dialogVisible=true
        this.url = url
      }
    },
    activated () {
      this.getFeedDetail()
    },
  }
</script>
<style>
  .incomeList{
    text-align: center;
    padding: 30px;
    font-size: 20px;
  }
</style>




// WEBPACK FOOTER //
// src/page/feeddetail.vue